<template>

	
	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 mx-auto user-panel mb-5">

                <div class="row page-header">
                    <div class="col">
                        <h3>Upcoming Videos</h3>
                    </div>
                </div>
				
                <div class="row">
                    <div class="col">
                        <h3>Uploading Videos</h3>
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th class="w-10">Stringer</th>
                                    <th class="w-40">Title</th>
                                    <th class="actions-col"></th>
                                    <th class="w-30">Progress</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="video in uploading">
                                    <td>{{ video.user.name }}</td>
                                    <td>{{ video.title }}</td>

                                    <td class="actions-col">
                                        <button class="btn btn-danger btn-sm" v-on:click="removeUpload(video.id)" v-if="canBeDeleted(video.updated_at)">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>

                                    <td v-if="video.status == 'uploading'">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated" v-bind:style="{ width: video.progress + '%' }">
                                                {{ Math.round(video.progress) + '%' }}
                                            </div>
                                        </div>
                                    </td>
                                    
                                    <td v-if="video.status == 'upload_paused'">
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning" v-bind:style="{ width: video.progress + '%' }">
                                                {{ Math.round(video.progress) + '%' }}
                                            </div>
                                        </div>
                                    </td>
                                    
                                </tr>
                                <tr v-if="uploading.length == 0">
                                    <td colspan="4" class="text-center">There are currently no uploads occuring.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="row mt-5">
                    <div class="col">
                        <h3>Processing Videos</h3>
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th class="w-10">Stringer</th>
                                    <th class="w-40">Title</th>
                                    <th class="w-30">Progress</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="video in processing">
                                    <td>{{ video.user.name }}</td>
                                    <td>{{ video.title }}</td>

                                    <td>
                                        <div class="progress">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated" v-bind:style="{ width: determineProgress(video.status) }">
                                                {{ video.status | displayProgress }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="processing.length == 0">
                                    <td colspan="3" class="text-center">There are currently videos being processed.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class="row mt-5">
                    <div class="col">
                        <h3>Videos Pending Approval</h3>
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th class="w-10">Preview</th>
                                    <th class="w-50">Video Details</th>
                                    <th class="w-10">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="video in pending">
                                    <td><progressive-img class="video-thumbnail" fallback="/static/image-unavailable.png" :src="video.thumbnailUrl" /></td>
                                    <td>
                                        <strong>{{ video.title }}</strong> <br/>
                                        {{ video.created_at | displayLocalDateTime }}<br/>
                                        Duration: {{ video.length | timecode}} <br/>
                                        Uploaded by: {{ video.user.name }}
                                    </td>
                                    <td>
                                        <button class="btn btn-primary btn-block" v-on:click="viewApprovalModal(video)" data-toggle="modal" data-target="#approveVideoModal">View</button>
                                        <button class="btn btn-danger btn-block" v-on:click="removeUpload(video.id)">Delete Video</button>
                                    </td>
                                </tr>
                                <tr v-if="pending.length == 0">
                                    <td colspan="3" class="text-center">There are currently no videos pending approval.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                 <div class="row mt-5" v-if="errors.length > 0">
                    <div class="col">
                        <h3>Video Errors</h3>
                        <table class="table mt-2">
                            <thead>
                                <tr>
                                    <th class="w-10">Preview</th>
                                    <th class="w-50">Video Details</th>
                                    <th class="w-10">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="video in errors">
                                    <td><progressive-img class="video-thumbnail" fallback="/static/image-unavailable.png" :src="video.thumbnailUrl" /></td>
                                    <td>
                                        <strong>{{ video.title }}</strong> <br/>
                                        {{ video.created_at | displayLocalDateTime }}<br/>
                                        Duration: {{ video.length | timecode}} <br/>
                                        Uploaded by: {{ video.user.name }}
                                    </td>
                                    <td>
                                        <button class="btn btn-primary btn-block" v-on:click="viewApprovalModal(video)" data-toggle="modal" data-target="#approveVideoModal">View</button>
                                    </td>
                                </tr>
                                <tr v-if="pending.length == 0">
                                    <td colspan="3" class="text-center">There are currently no videos pending approval.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


			</div>
		</div>

        <approve-video-modal></approve-video-modal>

	</div>

			
</template>

<script>
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import ApproveVideoModal from './modals/ApproveVideoModal'
    import { EventBus } from '../../utils/events';
    import moment from 'moment';
    

	export default {
		name: 'AdminUpcomingVideos',
		data () {
			return {
                uploading: {},
                processing: {},
                pending: {},
                errors: {},

                interval: null,
			}
        },
        components: {
			'approve-video-modal': ApproveVideoModal
		},
        mounted() {
            this.getUpcomingVideos();


            this.interval = setInterval(function () {
                this.getUpcomingVideos();
            }.bind(this), 5000);
            
            this.$nextTick(function () {
                EventBus.$on('admin-approve-video-refresh-data', this.getUpcomingVideos);
            }.bind(this));
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getUpcomingVideos() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/videos/upcoming", this.getAuthorizationHeader()).then((response) => {
                    _this.uploading = response.data.uploading
                    _this.processing = response.data.processing
                    _this.pending = response.data.pending
                    _this.errors = response.data.errors
                });
            },
            viewApprovalModal(video) {
                EventBus.$emit('admin-approve-video-open-modal', video);
            },
            determineProgress(status) {
                if(status == 'trf_aws') {
                    return '25%'
                }
                if(status == 'aws_trans') {
                    return '50%'
                }
                if(status == 'yt_uploading') {
                    return '75%'
                }
                if(status == 'yt_process') {
                    return '100%'
                }
            },

            removeUpload(id) {

                this.$swal({
                    title: 'Continue?',
                    text: "Are you sure you want to remove this upload?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, remove upload.'
                }).then((result) => {
                    if (result.value) {

                        var data = {
                            id: id,
                        }

                        var _this = this;
                        this.$http.post(Config.apiPath + "/api/v2/admin/videos/remove", data, this.getAuthorizationHeader()).then((response) => {
                            if(response.status == 200) {

                                _this.getUpcomingVideos();

                            }
                        });

                    }

                });                

            },

            canBeDeleted(updated_at) {

                var update = moment.utc(updated_at)
                var now = moment.utc(new Date())

                if(Math.abs(update.diff(now, 'minutes')) > 10) {
                    return true
                }

                return false

            }
            
        },
        beforeDestroy: function() {
            clearInterval(this.interval);
            console.log('cleared interval')
        },
        filters: {
            timecode: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }                
                    return minutes + ':' + seconds;
                }
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm:ss a');
            },
            displayProgress: function(value) {
                if(value == 'trf_aws') {
                    return 'Transferring video to AWS for transcoding.'
                }
                if(value == 'aws_trans') {
                    return 'AWS is currently transcoding this video.'
                }
                if(value == 'yt_uploading') {
                    return 'Uploading video to YouTube.'
                }
                if(value == 'yt_process') {
                    return 'YouTube is currently processing this video.'
                }
            }
        }
	}
</script>

<style scoped>

    .actions-col {
        padding: 0px;
        text-align: right;
        padding-right: 10px;
        max-width: 40px;
    }

</style>
